<template>
    <div class="paginator flex-level">
        <div v-if="pagination.total > 0" class="mx-2 fs-3">
            {{ $l10n.n__('%s ligne', '%s lignes', pagination.total, pagination.total) }}
        </div>

        <div v-if="displayActions && pagination.last_page > 0" class="flex-level mx-2">
            <div class="flex-level w-120 white-bkg page-indicator">
                <input
                    v-model="current_page"
                    type="number"
                    class="no-border primary-50 aright hp-10 p-0 wp-5"
                    @change="goToPage()"
                />
                <span class="dinlineb wp-4"> / {{ pagination.last_page }}</span>
            </div>
            <CompassIconButton
                icon="caret-left"
                size="small"
                :disabled="current_page === 1"
                @click="prevPage()"
            />
            <CompassIconButton
                icon="caret-right"
                size="small"
                :disabled="current_page === pagination.last_page"
                @click="nextPage()"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        pagination: {
            type: Object,
            required: false,
            default() {
                return {
                    current_page: 1,
                    last_page: 1,
                    total: 0,
                };
            },
        },
        displayActions: {
            type: Boolean,
            required: false,
            default: true,
        },
    },

    data() {
        return {
            current_page: 1,
        };
    },

    watch: {
        pagination(newVal) {
            this.$nextTick(function () {
                if (newVal.current_page !== '') {
                    this.current_page = parseInt(newVal.current_page, 10);
                }
            });
        },
    },

    methods: {
        prevPage() {
            if (this.current_page > 1) {
                this.current_page -= 1;
                this.update();
            }
        },
        nextPage() {
            if (this.current_page < this.pagination.last_page) {
                this.current_page += 1;
                this.update();
            }
        },

        goToPage() {
            if (this.current_page <= this.pagination.last_page && this.current_page >= 1) {
                this.update();
                return;
            }

            this.current_page = parseInt(this.pagination.current_page, 10);
        },

        update() {
            this.$emit('pagination:update', this.current_page);
        },
    },
};
</script>

<style scoped>
.page-indicator {
    height: 22px;
}
</style>
